export default __webpack_public_path__ + "static/media/backgroundmobile.72c48810.png";